import { URL } from 'react-native-url-polyfill';

// Only files prepared by the host's PDF loader may enter the private WebView.
// An artifact cannot turn an arbitrary file:// link into local read access.
const files = new Set();
export function registerMacPdfFile(uri) {
  const url = new URL(uri);
  if (url.protocol !== 'file:') throw new Error('Invalid prepared PDF file');
  url.hash = '';
  const key = url.href;
  files.add(key);
  return () => files.delete(key);
}
export function isPreparedMacPdfFile(uri) { return files.has(uri); }
